import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { CommonFunctionService } from './common-services/common-function.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
	title = 'app';
	public isLoadingSpinner: boolean;
	private isLoadingSpinnerSub: Subscription;
	constructor(
		private commonFuncService: CommonFunctionService
	){}	
	ngOnInit() {
		this.isLoadingSpinnerSub = this.commonFuncService.loadingSpinner.subscribe((isLoading) => {
			this.isLoadingSpinner = isLoading;
		})
	}
	ngOnDestroy() {
		this.isLoadingSpinnerSub.unsubscribe();
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts